import { c as _c } from "react/compiler-runtime";
import { useQuery } from "@tanstack/react-query";
import { usePathname } from "next/navigation";
import axiosInstance from "./axios";

/**
 * Fetch the list of indications for the review popup's Indication
 * Selection step.
 *
 * FDA products: hits `/products/indications/:productID` which runs an
 * LLM disease-extraction round-trip against `indications_and_usage`.
 *
 * Pipeline drugs: hits `/pipeline-drugs/indications/:slug` which just
 * returns the deduped `conditions[]` we already store from CT.gov.
 *
 * Same response shape (`{ indicationsList: string[] }`) so the popup
 * component doesn't need to know which kind of drug it's reviewing.
 */
const getIndications = async (productID, isPipeline) => {
  const endpoint = isPipeline ? `/pipeline-drugs/indications/${productID}` : `/products/indications/${productID}`;
  const response = await axiosInstance.get(endpoint);
  return response.data;
};
export const useIndicationsQuery = productID => {
  const $ = _c(12);
  const pathname = usePathname();
  const t0 = pathname || "";
  let t1;
  if ($[0] !== t0) {
    t1 = t0.startsWith("/pipeline/");
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const isPipeline = t1;
  const t2 = isPipeline ? "pipeline" : "product";
  let t3;
  if ($[2] !== productID || $[3] !== t2) {
    t3 = ["indications", productID, t2];
    $[2] = productID;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== isPipeline || $[6] !== productID) {
    t4 = () => getIndications(productID, isPipeline);
    $[5] = isPipeline;
    $[6] = productID;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const t5 = !!productID;
  let t6;
  if ($[8] !== t3 || $[9] !== t4 || $[10] !== t5) {
    t6 = {
      queryKey: t3,
      queryFn: t4,
      enabled: t5
    };
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  return useQuery(t6);
};
export default useIndicationsQuery;